import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';

import { ApiService } from '../../app/services/api.service';
import { GridPage } from '../grid/grid';
import { Localization } from '../../app/app.localization';
import { OkageGoGoogleAnalyticsProvider } from '../../providers/okage-go-google-analytics/okage-go-google-analytics';

@Component({
    selector: 'page-purchase',
    templateUrl: 'purchase.html',
    providers: [ApiService]
})


export class PurchasePage {
    loading: any;
    purchaseStatus: number;

    constructor(public navCtrl: NavController,
        private _apiService: ApiService,
        private _loc: Localization,
        private _ga: OkageGoGoogleAnalyticsProvider,
        private loadingCtrl: LoadingController) {

        this.purchaseStatus = 0;

        console.log(this);
        this.presentLoading();
        setTimeout(function(){
            this.purchaseStatus = 1;
            this.dismissLoading();
        }.bind(this), 1000);
        // start login qrcode
    }

    ionViewWillEnter() {
        this._ga.purchasePageView();
    }

    presentLoading(){
        this.loading = this.loadingCtrl.create();
        this.loading.present();
    }
    dismissLoading(){
        if(this.loading){
            this.loading.dismiss();
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/purchase/purchase.ts